import styled, {css} from 'styled-components';

import {ms} from '../../styles/normalizeSize';
import {Image} from '../../uikit/Image';
import {View} from '../../uikit/View';
import bgSvg from './assets/bg.svg';

export const Container = styled(View)`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${ms(150)};
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  min-width: ${ms(250)};
`;

export const Table = styled(View)`
  flex: 0.08;
  width: 100%;
  background-color: #444eb9;
  z-index: 1;
`;

export const Background = styled(bgSvg).attrs({
  preserveAspectRatio: 'xMidYMid slice',
})`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const imageCss = css`
  flex: 0.6;
  position: relative;
  top: 5%;
  z-index: 2;
`;

export const LiveStuff = styled(Image).attrs({
  resizeMode: 'contain',
  src: require('./assets/stuff-live.png'),
})<{src?: string}>`
  ${imageCss};
`;

export const ChatStuff = styled(Image).attrs({
  resizeMode: 'contain',
  src: require('./assets/stuff-chat.png'),
})<{src?: string}>`
  ${imageCss};
`;
